import { render, staticRenderFns } from "./ItineraryDay.vue?vue&type=template&id=c2ca6cc4&scoped=true&"
import script from "./ItineraryDay.vue?vue&type=script&lang=js&"
export * from "./ItineraryDay.vue?vue&type=script&lang=js&"
import style0 from "./ItineraryDay.vue?vue&type=style&index=0&id=c2ca6cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ca6cc4",
  null
  
)

export default component.exports